module.exports = __webpack_public_path__ + "img/racecourse-fairview-turf-1300.bb620414.svg";